// app/(tabs)/admin/taxonomy.tsx
import React from "react";
import AdminTaxonomyHome from "@/components/admin/AdminTaxonomyHome";

export default function AdminTaxonomyScreen() {
  return <AdminTaxonomyHome />;
}
